import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ConnectViewResidencesRotation from './ConnectViewResidencesRotation';
import ConnectViewResidencesUIRotate from './ConnectViewResidencesUIRotate';
import ConnectViewResidencesLevelGroup from './ConnectViewResidencesLevelGroup';
import ConnectViewResidencesApartment from './ConnectViewResidencesApartment';
import ConnectViewResidencesDayNight from './ConnectViewResidencesDayNight';
import ConnectViewResidencesMenu from './ConnectViewResidencesMenu';
import LoadContainer from '../../shared/LoadContainer';
import { resetResidences, updateRotation, toggleDayNight } from './';
import './stylesResidences.scss';
import './stylesResidencesMenu.scss';

function ViewResidences({ resetResidences, updateRotation, toggleDayNight, isLevelGroupActive }) {
  useEffect(() => {
    resetResidences();
    updateRotation(0);
    toggleDayNight('Day');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const rotations = [];
  for (let i = 0; i <= 72; i++) {
    rotations.push(<ConnectViewResidencesRotation key={i} rotation={i} />);
  }

  return (
    <div className={isLevelGroupActive ? 'residences--floorplate-open' : ''}>
      <LoadContainer>
        <div className="residences--rotations">
          {rotations}
        </div>
        <div className='residences--building-container'>
          <ConnectViewResidencesDayNight />
          <ConnectViewResidencesUIRotate />
        </div>
        <ConnectViewResidencesLevelGroup />
        <ConnectViewResidencesApartment />
      </LoadContainer>
      <ConnectViewResidencesMenu />
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLevelGroupActive: state.residences.isLevelGroupActive,
});

const mapDispatchToProps = { resetResidences, updateRotation, toggleDayNight };

export default connect(mapStateToProps, mapDispatchToProps)(ViewResidences);
